import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_reset_moving_average_cost_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_code: fromDatatype.VarcharDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  total_qty : fromDatatype.NumericDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  current_cost_ma_per_unit: fromDatatype.NumericDatatypeInterface;
  new_cost_ma_per_unit: fromDatatype.NumericDatatypeInterface;
  current_ma_cost_amount: fromDatatype.NumericDatatypeInterface;
  new_ma_cost_amount: fromDatatype.NumericDatatypeInterface;
  current_adjustment_per_unit: fromDatatype.NumericDatatypeInterface;
  new_adjustment_per_unit: fromDatatype.NumericDatatypeInterface;
  current_adjustment_amount: fromDatatype.NumericDatatypeInterface;
  new_adjustment_amount: fromDatatype.NumericDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  desc: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
}

export class bl_inv_reset_moving_average_cost_line_RowClass implements bl_inv_reset_moving_average_cost_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_code: fromDatatype.VarcharDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  total_qty : fromDatatype.NumericDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  current_cost_ma_per_unit: fromDatatype.NumericDatatypeInterface;
  new_cost_ma_per_unit: fromDatatype.NumericDatatypeInterface;
  current_ma_cost_amount: fromDatatype.NumericDatatypeInterface;
  new_ma_cost_amount: fromDatatype.NumericDatatypeInterface;
  current_adjustment_per_unit: fromDatatype.NumericDatatypeInterface;
  new_adjustment_per_unit: fromDatatype.NumericDatatypeInterface;
  current_adjustment_amount: fromDatatype.NumericDatatypeInterface;
  new_adjustment_amount: fromDatatype.NumericDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  desc: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
}